module.exports = __webpack_public_path__ + "static/media/whishlist-leadimage.bca933d0.jpg";